/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamExamidLangsMutationRequest,
  PostApiV1ExamExamidLangsMutationResponse,
  PostApiV1ExamExamidLangsPathParams,
  PostApiV1ExamExamidLangs401,
  PostApiV1ExamExamidLangs404,
  PostApiV1ExamExamidLangs500,
} from "../../types/examEvaluationController/PostApiV1ExamExamidLangs.ts";

function getPostApiV1ExamExamidLangsUrl(
  examId: PostApiV1ExamExamidLangsPathParams["examId"],
) {
  const res = { method: "POST", url: `/api/v1/exam/${examId}/langs` as const };
  return res;
}

/**
 * @description Cria um novo idioma para a prova informada. O idioma (CultureInfo) deve ser único por prova. **(Requer Authorization para autenticação)**
 * @summary Criar idioma de prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examId/langs}
 */
export async function postApiV1ExamExamidLangs(
  examId: PostApiV1ExamExamidLangsPathParams["examId"],
  data?: PostApiV1ExamExamidLangsMutationRequest,
  config: Partial<RequestConfig<PostApiV1ExamExamidLangsMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1ExamExamidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamExamidLangs401
      | PostApiV1ExamExamidLangs404
      | PostApiV1ExamExamidLangs500
    >,
    PostApiV1ExamExamidLangsMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ExamExamidLangsUrl(examId).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
